import { useCallback, useState } from 'react';

import { getTicketDownloadStatus } from './use-get-ticket-download-status';

interface TicketNotAvailableModalProps {
  isOpen: boolean;
  onClose: () => void;
}

interface UseCheckTicketDownloadReturn {
  checkAndDownload: (token: string, onAvailable: () => void) => Promise<void>;
  isChecking: boolean;
  modalProps: TicketNotAvailableModalProps;
}

export const useCheckTicketDownload = (): UseCheckTicketDownloadReturn => {
  const [isChecking, setIsChecking] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const checkAndDownload = useCallback(async (token: string, onAvailable: () => void) => {
    setIsChecking(true);

    try {
      const status = await getTicketDownloadStatus(token);

      if (status.isAvailable) {
        onAvailable();
      } else {
        setIsModalOpen(true);
      }
    } catch {
      setIsModalOpen(true);
    } finally {
      setIsChecking(false);
    }
  }, []);

  return {
    checkAndDownload,
    isChecking,
    modalProps: {
      isOpen: isModalOpen,
      onClose: closeModal,
    },
  };
};
